import _ from "underscore";
import { CampaignComponentVariableCommonImpl } from "./CampaignComponentVariableCommonImpl";
import { CampaignComponentSetting } from "./CampaignComponentSetting";
export const isCampaignComponentVariable = (setting) => {
    return setting instanceof CampaignComponentVariable;
};
class CampaignComponentVariable extends CampaignComponentSetting {
    constructor(variableResponse, context) {
        super(variableResponse, context);
        this.name = variableResponse.name;
        this.display_name = variableResponse.display_name;
        this.description = variableResponse.description;
        this.source = variableResponse.source;
        this.tags = variableResponse.tags;
        this.priority = variableResponse.priority;
        this.values = variableResponse.values;
        this.context = context;
        this.campaignComponentVariableCommonImpl =
            new CampaignComponentVariableCommonImpl({
                name: this.name,
                display_name: this.display_name,
                tags: this.tags,
                type: this.type,
                values: this.values,
            });
    }
    getDimensions() {
        return _.keys(this.values);
    }
    getValue(variant) {
        return this.campaignComponentVariableCommonImpl.getValue(variant);
    }
    hasVariant(variant) {
        return this.campaignComponentVariableCommonImpl.hasVariant(variant);
    }
}
CampaignComponentVariable.DEFAULT_DIMENSION = "default";
const variableTypeOptionDefinitions = {
    STRING: {
        displayName: "String",
        value: "STRING",
    },
    BOOLEAN: {
        displayName: "Boolean",
        value: "BOOLEAN",
    },
    INTEGER: {
        displayName: "Integer",
        value: "INTEGER",
    },
    STRING_LIST: {
        displayName: "String List",
        value: "STRING_LIST",
    },
    INTEGER_LIST: {
        displayName: "Integer List",
        value: "INTEGER_LIST",
    },
    DELAY_LIST: {
        displayName: "Delay List",
        value: "DELAY_LIST",
    },
    DELAY: {
        displayName: "Delay",
        value: "DELAY",
    },
    JSON: {
        displayName: "Json",
        value: "JSON",
    },
    COLOR: {
        displayName: "Color",
        value: "COLOR",
    },
    IMAGE: {
        displayName: "Image",
        value: "IMAGE",
    },
    FONT: {
        displayName: "Font",
        value: "FONT",
    },
    URL: {
        displayName: "Url",
        value: "URL",
    },
    CLIENT_KEY_FLOW: {
        displayName: "Client Key Flow",
        value: "CLIENT_KEY_FLOW",
    },
    CLIENT_KEY: {
        displayName: "Client Key",
        value: "CLIENT_KEY",
    },
    EXTOLE_CLIENT_KEY: {
        displayName: "Extole Client Key",
        value: "EXTOLE_CLIENT_KEY",
    },
    REWARD_SUPPLIER_ID: {
        displayName: "Reward Supplier Id",
        value: "REWARD_SUPPLIER_ID",
    },
    REWARD_SUPPLIER_ID_LIST: {
        displayName: "Reward Supplier Id List",
        value: "REWARD_SUPPLIER_ID_LIST",
    },
    CLIENT_DOMAIN_ID_LIST: {
        displayName: "Client Domain Id List",
        value: "CLIENT_DOMAIN_ID_LIST",
    },
    SOCKET: {
        displayName: "Socket",
        value: "SOCKET",
    },
    MULTI_SOCKET: {
        displayName: "Multi Socket",
        value: "MULTI_SOCKET",
    },
    HTML: {
        displayName: "Html",
        value: "HTML",
    },
    ENUM: {
        displayName: "Enum",
        value: "ENUM",
    },
    ENUM_LIST: {
        displayName: "Enum List",
        value: "ENUM_LIST",
    },
    PARTNER_ENUM: {
        displayName: "Partner Enum",
        value: "PARTNER_ENUM",
    },
    PARTNER_ENUM_LIST: {
        displayName: "Partner Enum List",
        value: "PARTNER_ENUM_LIST",
    },
    AUDIENCE_ID: {
        displayName: "Audience Id",
        value: "AUDIENCE_ID",
    },
    ADMIN_ICON: {
        displayName: "Admin Icon",
        value: "ADMIN_ICON",
    },
    COMPONENT_ID: {
        displayName: "Component Id",
        value: "COMPONENT_ID",
    },
};
export const variableTypeOptions = _.values(variableTypeOptionDefinitions);
const variableSourceOptionDefinitions = {
    LOCAL: {
        displayName: "Local",
        value: "LOCAL",
    },
    INHERITED: {
        displayName: "Inherited",
        value: "INHERITED",
    },
    PARAMETER: {
        displayName: "Parameter",
        value: "PARAMETER",
    },
};
export const variableSourceOptions = _.values(variableSourceOptionDefinitions);
export default CampaignComponentVariable;
